import {
  Button,
  ButtonGroup,
  Text,
  Stack
} from '@leroy-merlin-br/backyard-react'
import {
  useClearRefinements,
  useCurrentRefinements,
  useStats
} from 'react-instantsearch'

import { useAlgoliaContext } from 'site/AlgoliaEntryKey/context/algolia-context'

import * as S from './styled'

const Footer = () => {
  const { toggleMobileFilter } = useAlgoliaContext()

  const { nbHits: totalCount } = useStats()
  const { refine: cleanFilters } = useClearRefinements()
  const { items } = useCurrentRefinements()

  const TotalProductsLabel =
    totalCount === 1 ? 'Produto encontrado' : 'Produtos encontrados'

  const hasFiltersSelected = Boolean(items.length)

  return (
    <S.Footer>
      <Stack space="giga" alignX="center">
        <S.TotalProducts>
          <Text size="mega" as="span" isBold noMargin>
            {totalCount}{' '}
          </Text>
          <Text size="mega" as="span" isBold noMargin>
            {TotalProductsLabel}
          </Text>
        </S.TotalProducts>

        <ButtonGroup label="botões de filtros" align="center" inlineMobile>
          <Button
            variant="outline"
            size="mega"
            appearance="primary"
            isDisabled={!hasFiltersSelected}
            onClick={cleanFilters}
          >
            Limpar filtros
          </Button>

          <Button size="mega" onClick={toggleMobileFilter}>
            Aplicar filtros
          </Button>
        </ButtonGroup>
      </Stack>
    </S.Footer>
  )
}

export default Footer
